import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CustomerAuthProvider } from "@/context/CustomerAuth";
import Landing from "@/pages/Landing";
import Manage from "@/pages/Manage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ResetPassword from "@/pages/ResetPassword";

function App() {
  return (
    <div className="App">
      <CustomerAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/gerer/:token" element={<Manage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </CustomerAuthProvider>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
